export const types = { 
    estate:'estate',
    villa:'villa',
    lotti:'lotti',
    development:'development'
}
